// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../../../Fields/FieldsImport';
import { FieldsFactory } from '../../../Factory/FieldsFactory';
export class AlgorithmHeatmapInstrumentGroup extends PFixFieldSet {
    constructor(groupId, pfixFieldSet) {
        super(groupId, null, pfixFieldSet);
    }
    get TradableId() {
        return super.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    get RouteID() {
        return super.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    get LastPrice() {
        return super.GetValue(FieldsFactory.FIELD_LAST_PRICE);
    }
    get PercentChange() {
        return super.GetValue(FieldsFactory.FIELD_INTEREST_CHANGE);
    }
    get Change() {
        return super.GetValue(FieldsFactory.FIELD_ABSOLUTE_CHANGE);
    }
}
